/*
 * Hosted landing page URLs are `{label}.{base_domain}`, where base_domain comes
 * from the API (`landing_pages.base_domain`).
 *
 * There is deliberately no fallback host here. The base domain changed when
 * landing pages moved off spokeapp.io, so guessing would show a confidently
 * wrong domain; rendering nothing is the visible failure we want if a query
 * forgets to select the field.
 */
export function landingPageHost(landingPage) {
  const { domain, base_domain: baseDomain } = landingPage ?? {};

  return domain && baseDomain ? `${domain}.${baseDomain}` : '';
}
